
export const GetAllSearchParams = (searchParams: URLSearchParams) => {
    const params = {};
    searchParams.forEach((value, key) => {
        // @ts-ignore
        params[key]=value;
    })
    return params;
}
